import { render, staticRenderFns } from "./profit_transfer_payment_check.vue?vue&type=template&id=66c02479&scoped=true"
import script from "./profit_transfer_payment_check.vue?vue&type=script&lang=js"
export * from "./profit_transfer_payment_check.vue?vue&type=script&lang=js"
import style0 from "./profit_transfer_payment_check.vue?vue&type=style&index=0&id=66c02479&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c02479",
  null
  
)

export default component.exports